import { createFileRoute } from "@tanstack/react-router";
import Evolucao from "@/pages/app/Evolucao";

export const Route = createFileRoute("/app/evolucao")({
  head: () => ({ meta: [{ title: "Evolução | Braussie - Nutri" }] }),
  component: Evolucao,
});
